import { useSearchParams } from 'react-router-dom-v5-compat';

export const useUrlSearchParams = () => {
  const [searchParams] = useSearchParams();

  return Object.fromEntries([...searchParams]);
};
